<template>
    <div class="tablenav-pages">
        <span class="displaying-num">{{( totalItems === null) ? 0 : totalItems }} {{stEditorStrings.items}}</span>
        <span class="pagination-links">
            <span class="tablenav-pages-navspan button"
                  :title="stEditorStrings.first_page"
                  @click="$emit( 'input', ( value <= 2 ) ? value : 1 )"
                  :class="{ 'disabled' : value <= 2 }">«</span>
            <span class="tablenav-pages-navspan button"
                  :title="stEditorStrings.previous_page"
                  @click="$emit( 'input',  ( value <= 1 ) ? value : value - 1 )"
                  :class="{ 'disabled' : value <= 1 }">‹</span>
            <span class="paging-input">
                <input class="current-page" :class="{ 'wrong-value' : wrongPageValue }" type="text" name="paged" size="1"
                       aria-describedby="table-paging" :value="value" @change="$emit( 'input', $event.target.value)"
                        :title="(wrongPageValue) ? stEditorStrings.wrong_page : stEditorStrings.navigate_to_page">
                <span class="tablenav-paging-text">
                    {{stEditorStrings.of}}
                    <span class="total-pages">{{ totalNumberOfPages }}</span>
                </span>
            </span>
            <span class="tablenav-pages-navspan button"
                  :title="stEditorStrings.next_page"
                  :class="{ 'disabled' : value >= totalNumberOfPages }"
                  @click="$emit( 'input',( value >= totalNumberOfPages ) ? value : value + 1 )">›</span>
            <span class="tablenav-pages-navspan button"
                  :title="stEditorStrings.last_page"
                  @click="$emit( 'input', ( value >= totalNumberOfPages - 1 ) ? value : totalNumberOfPages )"
                  :class="{ 'disabled' : value >= (totalNumberOfPages - 1)  }">»</span>
        </span>
    </div>
</template>

<script>
    export default {
        props : [
            'value',
            'totalNumberOfPages',
            'stEditorStrings',
            'totalItems',
            'wrongPageValue'
        ],
        data() {
            return {
                page : this.value
            }
        },
        watch : {
            value : function ( newValue, oldValue ) {
                this.page = newValue
            }
        }
    }
</script>